/*
 * Glow Saunas — Unified Element Fade-in
 * ------------------------------------------------------------
 * On every page load:
 *   1. Find every body content element (p/h1-h6/img/video/etc).
 *   2. Add .glow-fade-init to start them hidden.
 *   3. IntersectionObserver adds .glow-fade-in (visible) as each
 *      enters the viewport — triggered 15% BEFORE the element
 *      hits the bottom edge so the reveal feels instant, never
 *      late.
 *
 * Unlike the earlier version, this one does NOT try to detect
 * pre-existing animations. The companion CSS file silences
 * those so a single fade plays everywhere consistently.
 *
 * Skips: header, footer, cart drawer, announcement bar — those
 * shouldn't fade on every navigation.
 * ------------------------------------------------------------
 */
(function () {
  if (typeof window === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR = [
    'p',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'img',
    'picture',
    'video',
    'iframe',
    'model-viewer',
    'figure',
    'blockquote',
    'ul', 'ol',
    '.button',
    'a.button',
    'button.button',
    '.product-media',
    '.media',
    '.image-with-text__media',
    '.card__media',
    '.card-information',
    '.card__information',
    '.benefit-card',
    '.hcbb__card',
    '.hcpillars__pillar'
  ].join(',');

  var SKIP_ANCESTORS = 'header, footer, .header, .footer, .header-wrapper, .footer-wrapper, .cart-drawer, .announcement-bar, .shopify-section-group-header-group, .shopify-section-group-footer-group, nav, .floating-nav, .mobile-drawer, .skip-to-content-link';

  function init() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll(SELECTOR).forEach(function (el) {
        el.classList.add('glow-fade-in');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('glow-fade-in');
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.05,
      // Positive bottom margin so elements start fading BEFORE they
      // actually enter the viewport. Eliminates that 'late reveal' feel.
      rootMargin: '0px 0px 15% 0px'
    });

    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.closest(SKIP_ANCESTORS)) return;
      el.classList.add('glow-fade-init');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // When Shopify's theme editor re-renders a section, immediately reveal
  // any new content inside it (no waiting for IntersectionObserver) so
  // edits never get stuck at opacity 0 in the editor preview.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target || document;
    root.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.closest(SKIP_ANCESTORS)) return;
      el.classList.add('glow-fade-init', 'glow-fade-in');
    });
    // Also re-run init for any newly visible elements outside the editor
    // (covers programmatic section unhide etc).
    init();
  });
})();
